
















import Vue from 'vue'

export default Vue.extend({
  name: 'CTA',
  props: [
    'cta',
    'action',
    'to',

    'variant'
  ]
})
